<layout-sidebar>
  <div class="main">
    <p>
      We're proud to partner with Safelite for your windshield or window glass repairs. It's quick
      and easy to file a claim! Just answer a few questions, and we'll send you to Safelite to
      finish up your claim.
    </p>
    <div class="report-claim">
      <form [formGroup]="riskSelectionForm" (ngSubmit)="navigateToGlassClaim()">
        <!-- The data has not come back yet -->
        @if (dataLoading | async) {
          <ds-localized-spinner
            class="block pad-bottom-20"
            [dataLoading]="dataLoading | async"
            [loadingMessage]="'Looking for risks...'"
          >
          </ds-localized-spinner>
        }

        @if ((dataLoading | async) === false) {
          <div>
            <div class="row pad-bottom-10">
              <h4 class="heading-sub-section">Which item needs a claim?</h4>
              <fieldset>
                <ds-risk-list
                  [risks]="risks"
                  (riskChange)="changeRisk($event)"
                  (onContactUsClick)="openContactUs()"
                  data-cy="riskList"
                >
                </ds-risk-list>
              </fieldset>
            </div>
            <div class="row">
              <h4 class="heading-sub-section">When did the damage happen?</h4>
              <div class="column twelve md-five">
                <mat-form-field [formGroup]="dateGroup" appearance="outline" style="width: 100%">
                  <input
                    matInput
                    [max]="matDatePickerOptions.maxDate"
                    [matDatepicker]="picker"
                    formControlName="dateOfIncident"
                    readonly
                  />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-label>Date of Incident</mat-label>
                </mat-form-field>
              </div>
            </div>
          </div>
        }

        <div class="row callToAction">
          <span class="md-float-right">
            <a
              class="pad-horizontal-20"
              (click)="cancel()"
              dsContent
              [contentPath]="'shared.cancel'"
            ></a>
            <button
              ds-button
              type="submit"
              [disabled]="
                !riskSelectionForm.valid ||
                !(roleService.isAuthorized('reportglassclaim_select') | async)
              "
              dsContent
              [contentPath]="'claims.fnol.gotoSafelite'"
            ></button>
          </span>
        </div>
      </form>
    </div>
  </div>

  <aside class="main-aside">
    <links-agents-sidebar [quickLinksList]="quickLinksList"></links-agents-sidebar>
  </aside>
</layout-sidebar>
